export default "__VITE_ASSET__DjDLG3kd__"